import * as CryptoJS from 'crypto-js';
export function setFeatureFlag(config) {
    window.setFeatureFlag = (featureFlag, value) => {
      const props = config;
      if (!(props.featureFlagProps && props.featureFlagProps.key && props.featureFlagProps[featureFlag] && props.featureFlagProps[featureFlag].isSwitchEffective)) {
        console.error('No completed config for this feature flag, please contact admin to solve this.');
        return;
      }
      var encry = CryptoJS.HmacSHA384(featureFlag, props.featureFlagProps.key).toString();
      localStorage.setItem(encry, value);
    };
}